module.exports = __webpack_public_path__ + "static/media/lanqita.e12e7f32.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/lanqita.png
// module id = 2174
// module chunks = 0